<template>
  <div style="display: none" />
</template>

<script>
import { mapGetters } from 'vuex'

import { EventBus } from '@/services/eventbus'

export default {
  name: 'LianderGasleidingLayer',
  props: {
    /**
     * Indicates whether the MapBox instance is ready
     */
    loaded: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      layerName: 'liander_gasleiding',
      type: 'line',
      paint: {
        'line-width': 1,
      },
    }
  },
  computed: {
    ...mapGetters('deployment', [
      'MapboxAccount',
      'DeploymentLayerName',
    ]),
    ...mapGetters('prognose', [
      'labelLayer',
    ]),
    source() {
      return {
        url: `mapbox://${this.MapboxAccount}.${this.sourceName}`,
        layer: this.sourceName,
      }
    },
    sourceName() {
      return this.DeploymentLayerName({ layer: this.layerName })
    },
  },
  watch: {
    loaded(loaded) {
      if (!loaded) return

      this.addLayer()
    },
  },
  created() {
    if (this.loaded) {
      this.addLayer()
    }
  },
  methods: {
    /**
     * Add the layer
     */
    addLayer() {
      if (this.sourceName == false) return
      this.removeLayerAndSource()

      if (! this.sourceName) {
        console.error('LianderGasleidingLayer: No sourceName available')
        return
      }

      if (! this.source.url || ! this.source.layer) {
        console.error('LianderGasleidingLayer: Invalid source configuration', this.source)
        return
      }

      if (this.$store.map.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName)
      }
      if (this.$store.map.getSource(this.sourceName)) {
        this.$store.map.removeSource(this.sourceName)
      }
      this.$nextTick(() => {
        this.$store.map.addSource(this.sourceName, {
          type: 'vector',
          url: this.source.url,
        })

        this.$store.map.addLayer({
          'id': this.layerName,
          'type': this.type,
          'source': this.sourceName,
          'source-layer': this.source.layer,
          'paint': {
            ...this.paint,
            'line-color': [
              'case',
              ['<=', ['get', 'JAARAANLEG'], 1970], '#FFFF00',
              ['<=', ['get', 'JAARAANLEG'], 1980], '#b3c22f',
              ['<=', ['get', 'JAARAANLEG'], 1990], '#8fa646',
              ['<=', ['get', 'JAARAANLEG'], 2000], '#4d6f80',
              ['<=', ['get', 'JAARAANLEG'], 2010], '#1150ba',
              ['>', ['get', 'JAARAANLEG'], 2010], '#0242bd',
              '#b2b2b2'
            ]
          },
        }, this.labelLayer)

        EventBus.$emit('layers.national.loaded', {
          name: this.layerName,
        })
      })
    },
    removeLayerAndSource () {
      if (this.$store.map.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName)
        this.$store.map.removeSource(this.sourceName)
      }
    },
  },
}
</script>
